import * as z from "zod";

export const MetricSentiment = z.enum(["positive", "neutral", "concern"]);
export type MetricSentiment = z.infer<typeof MetricSentiment>;

const MetricAnalysis_ = z.object({
  value: z.union([z.number(), z.string(), z.boolean()]),
  sentiment: MetricSentiment,
  description: z.string().optional(),
});
export const MetricAnalysis: z.ZodType<MetricAnalysis> = MetricAnalysis_;
export interface MetricAnalysis extends z.infer<typeof MetricAnalysis_> {}

const CustomerMetrics_ = z.object({
  totalOrders: MetricAnalysis,
  totalReturns: MetricAnalysis,
  returnRate: MetricAnalysis,
  totalOrderValue: MetricAnalysis,
  averageOrderValue: MetricAnalysis,
});
export const CustomerMetrics: z.ZodType<CustomerMetrics> = CustomerMetrics_;
export interface CustomerMetrics extends z.infer<typeof CustomerMetrics_> {}

const ReturnMetrics_ = z.object({
  totalValue: MetricAnalysis.optional(),
  refundValue: MetricAnalysis.optional(),
  storeCreditValue: MetricAnalysis.optional(),
  exchangeValue: MetricAnalysis.optional(),
  productCount: MetricAnalysis,
  hasGreenReturnItems: MetricAnalysis.optional(),
  /** @deprecated Use hasGreenReturnItems instead */
  isGreenReturn: MetricAnalysis.optional(),
  isInstantExchange: MetricAnalysis,
});
export const ReturnMetrics: z.ZodType<ReturnMetrics> = ReturnMetrics_;
export interface ReturnMetrics extends z.infer<typeof ReturnMetrics_> {}

const AgentReviewMetrics_ = z.object({
  customer: CustomerMetrics,
  return: ReturnMetrics,
  collectedAt: z.coerce.date(),
});
export const AgentReviewMetrics: z.ZodType<AgentReviewMetrics> =
  AgentReviewMetrics_;
export interface AgentReviewMetrics extends z.infer<
  typeof AgentReviewMetrics_
> {}
